import { axiosInstance } from "./axiosInstance";

export const assetsService = {
  uploadAsset: async ({
    file,
    contentType,
    entityType,
    entityId,
    description,
    headers = {},
    signal,
  }) => {
    let cancelled = false;
    if (signal) {
      if (signal.aborted) throw new DOMException("Aborted", "AbortError");
      signal.addEventListener("abort", () => {
        cancelled = true;
        throw new DOMException("Aborted", "AbortError");
      });
    }
    const formData = new FormData();
    formData.append("file", file)
    formData.append("entityType", entityType);
    formData.append("entityId", entityId);
    formData.append("contentType", contentType);
    formData.append("description", description);
    try {
      try {
        const { data } = await axiosInstance.post(
          "/assets/upload", // Replace with actual base URL
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              ...headers,
            },
            signal,
            timeout: 0
          }
        );
        return data;
      } catch (error) {
        console.log(`An error occured when uploading asset ${entityType}`);
        throw error;
      }
    } catch (error) {
      console.log(error);
      if (cancelled) return true;
      return false;
    }
  },
  uploadURLAsset: async ({
    url,
    entityType,
    entityId,
    description,
    headers = {},
    signal,
    type,
  }) => {
    let cancelled = false;
    if (signal) {
      if (signal.aborted) throw new DOMException("Aborted", "AbortError");
      signal.addEventListener("abort", () => {
        cancelled = true;
        throw new DOMException("Aborted", "AbortError");
      });
    }
    const formdata = {
      url,
      entityId,
      entityType,
      description,
      type
    }
    try {
      try {
        const { data } = await axiosInstance.post(
          "/assets",
          formdata,
          {
            headers,
            signal,
            timeout: 0
          }
        );
        return data;
      } catch (error) {
        console.log(`An error occured when uploading asset ${entityType}`);
        throw error;
      }
    } catch (error) {
      console.log(error);
      if (cancelled) return true;
      return false;
    }
  },
  deleteAsset: async (assetId) => {
    try {
      await axiosInstance.delete(`/assets/${assetId}`);
    } catch (error) {
      console.log(`Error deleting asset ${assetId}`);
      throw error;
    }
  },
};
